<template>
    <div class="permissionContainer">
        <el-row v-has="'perimission:select'">
            <div class="add-menu-button">
                <el-button size="mini" type="primary" @click="add('dir')" icon="el-icon-folder-opened">添加目录</el-button>
                <el-button size="mini" type="primary" @click="add('menu')" icon="el-icon-menu">添加菜单</el-button>
                <el-button size="mini" type="primary" @click="add('button')" icon="el-icon-mouse">添加按钮</el-button>
                <el-button size="mini" type="danger" @click="del()" icon="el-icon-delete">删除</el-button>
            </div>
        </el-row>
        <el-row v-has="'perimission:select'">
            <el-col :span="7">
               
                <el-tree :data="permissions" @node-click="handleNodeClick" :expand-on-click-node="false" default-expand-all>
                    <span slot-scope="{node, data}">
                        <span>
                            <i :class='node.data.icon'></i>  &nbsp;&nbsp;{{ node.label }}
                            <span class="p" v-if="node.data.permissionsType == 1">(目录)</span>
                            <span class="m" v-else-if="node.data.permissionsType == 2">(菜单)</span>
                            <span class="b" v-else>(按钮)</span>
                        </span>
                    </span>
                </el-tree>
            </el-col>
            <el-col :span="17">
                <div>
                    <el-form :model="formData" status-icon :rules="rules" ref="form" label-width="100px" class="">
                        <el-form-item v-show="formShow.parentShow" label="上级">
                            <span class="parentName">{{formShow.parentName}}</span>
                        </el-form-item>
                        <el-form-item label="权限类型" prop="type">
                            <el-select disabled v-model="formData.type">
                                <el-option label="目录" value="1"></el-option>
                                <el-option label="菜单" value="2"></el-option>
                                <el-option label="按钮" value="3"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="权限名称" prop="name">
                            <el-input type="text" v-model="formData.name" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item v-show="formShow.iconShow" label="图标" prop="icon">
                            <el-input type="text" v-model="formData.icon" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item v-show="formShow.pathShow" label="访问路径" prop="path">
                            <el-input type="text" v-model="formData.path" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="排序" prop="sort">
                            <el-input-number size="small" v-model="formData.sort" :min="1" :max="100" label="描述文字"></el-input-number>
                        </el-form-item>
                        <el-form-item v-show="formShow.flagShow" label="权限标识" prop="flag">
                            <el-input type="text" v-model="formData.flag" autocomplete="off"  placeholder="例如 sys:edit  sys:del  配合v-has标签使用"></el-input>
                        </el-form-item>
                        <el-form-item hidden label="权限标识" prop="level">
                            <el-input type="text" v-model="formData.level"></el-input>
                        </el-form-item>
                        <el-form-item v-show="formShow.btnShow">
                            <el-button type="primary" @click="submitForm('form')">{{button}}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import { addMenu, updateMenu, getPermissionsAll,delMenu } from "@/api/index";

    export default {
        data() {
            var validateFlag = (rule, value, callback) => {
                if (this.formData.type === '3' && value === '') {
                    callback(new Error('按钮必须添加权限标识'));
                } else {
                    callback();
                }
            };
            return {
                permissions: [],
                button: '添加',
                formShow: {
                    iconShow: true,
                    pathShow: false,
                    flagShow: false,
                    btnShow: false,
                    parentId: 0,
                    parentName: '',
                    parentShow: false
                },
                formData:{
                    name: '',
                    icon: '',
                    type: '1',
                    path: '',
                    sort: 1,
                    flag: '',
                    level: 1
                },
                rules: {
                    name: [
                        { required: true, message:'请输入权限名称', trigger: 'blur' }
                    ],
                    type: [
                        { required: true, message:'请选择权限类型', trigger: 'change' }
                    ],
                    flag: [
                        { validator: validateFlag, trigger: 'blur' }
                    ],
                    sort: [
                        {
                            required: true, message:'排序不能为空'
                        }
                    ]
                }
            }
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.formShow.parentShow){
                            //添加
                            addMenu(this.formData).then(res => {
                                if (res.success == true) {
                                    this.$message({
                                        showClose: true,
                                        message: '添加成功',
                                        type: 'success'
                                    })
                                    this.getPermissionsAll()
                                }else{
                                    this.$message({
                                        showClose: true,
                                        message: res.message,
                                        type: 'error'
                                    })
                                }
                            });
                        }else{
                            //修改
                            updateMenu(this.formData).then(res => {
                                if (res.success == true) {
                                    this.$message({
                                        showClose: true,
                                        message: '修改成功,重新登录后生效',
                                        type: 'success'
                                    })
                                    this.getPermissionsAll()
                                }else{
                                    this.$message({
                                        showClose: true,
                                        message: res.message,
                                        type: 'error'
                                    })
                                }
                            });
                        }
                    } else {
                        return false;
                    }
                });
            },
            handleNodeClick(data) {
                this.$refs['form'].resetFields();
                this.formShow.parentShow = false
                this.formData.id = data.id
                this.formData.type = data.permissionsType+''
                this.formData.name = data.label
                this.formData.icon = data.icon
                this.formData.sort = data.sort
                this.formData.path = data.path
                this.formData.level = data.level
                this.formData.flag = data.roleFlag
                this.button = '修改'

                if(data.permissionsType == '3'){
                    this.formShow.iconShow = false
                    this.formShow.pathShow = false
                    this.formShow.flagShow = true
                }
                if(data.permissionsType == '2'){
                    this.formShow.iconShow = true
                    this.formShow.pathShow = true
                    this.formShow.flagShow = false
                }
                if(data.permissionsType == '1'){
                    this.formShow.iconShow = true
                    this.formShow.pathShow = false
                    this.formShow.flagShow = false
                }
                if(data.id == '0'){
                    this.formShow.btnShow = false
                }else{
                    this.formShow.btnShow = true
                }
            },
            getPermissionsAll(){
                let that = this
                getPermissionsAll({}).then(res => {
                    if (res.success == true) {
                        that.permissions = res.result
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        })
                    }
                });
            },
            del(){
                delMenu(this.formData.id).then(res => {
                    if (res.success == true) {
                        this.$message({
                            showClose: true,
                            message: '删除成功',
                            type: 'success'
                        })
                        this.getPermissionsAll()
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        })
                    }
                });
            },
            add(val){
                if(this.formData.name == ''){
                    return
                }
                if(this.button == '添加'){
                    return;
                }
                if(this.formData.type != '2' && val == 'button'){
                    this.$message({
                        showClose: true,
                        message: '只要菜单可以添加按钮权限',
                        type: 'warning'
                    })
                    return;
                }
                if(this.formData.type == '2' && val != 'button'){
                    this.$message({
                        showClose: true,
                        message: '菜单只可以添加按钮权限',
                        type: 'warning'
                    })
                    return;
                }
                this.button = '添加'
                if(this.formData.id == '0'){
                    this.formShow.btnShow = true
                }
                this.formShow.parentShow = true
                this.formShow.parentName = this.formData.name

                this.formData.name = ''
                this.formData.icon = ''
                this.formData.sort = 1
                this.formData.path = ''
                this.formData.flag = ''
                if(val == 'button'){
                    this.formShow.iconShow = false
                    this.formShow.pathShow = false
                    this.formShow.flagShow = true
                    this.formData.type = '3'
                }
                if(val == 'menu'){
                    this.formShow.iconShow = true
                    this.formShow.pathShow = true
                    this.formShow.flagShow = false
                    this.formData.type = '2'
                }
                if(val == 'dir'){
                    this.formShow.iconShow = true
                    this.formShow.pathShow = false
                    this.formShow.flagShow = false
                    this.formData.type = '1'
                }

            }
        },
        created(){
            this.getPermissionsAll()
        },
        mounted() {
        }
    }
</script>
<style lang="scss">
    
    .permissionContainer{
        background-color: #FFFFFF;
        padding: 16px;
        margin: 20px;
        border-radius: 10px;
        -webkit-box-shadow:0px 3px 3px #c8c8c8;
        -moz-box-shadow:0px 3px 3px #c8c8c8;
        box-shadow:0px 3px 3px #c8c8c8;

        .el-table--enable-row-hover .el-table__body tr:hover>td{
            background-color: #ECF5FF;
        }

        .add-menu-button{
            padding: 15px;
            width: 400px;
        }
        .parentName{
            font-size: 15px;
            font-weight: bold;
            color: red;
        }
        .p{
            font-size: 1px;
            color: #E6A23C;
        }
        .m{
            font-size: 1px;
            color: #67C23A;
        }
        .b{
            font-size: 1px;
            color: #409EFF;
        }
        .el-tree-node.is-current > .el-tree-node__content {
            background-color: #c2d6ea !important;
        }
    }
    
</style>
